export const getCookie = (name: string) => {
  const cookies: Record<string, string> = document.cookie
    .split("; ")
    .map((cookie) => cookie.split("="))
    .reduce((acc: Record<string, string>, [key, value]) => {
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {});

  return cookies[name] || null;
};
